module.exports = __webpack_public_path__ + "static/media/new-fidelity-card.b4e7037e.png";